import React from "react";
import {
  Box,
  Flex,
  HStack,
  VStack,
  Image,
  Text,
  Link,
  SimpleGrid,
  Icon,
  Divider,
  useColorModeValue,
} from "@chakra-ui/react";
import { BsLinkedin } from "react-icons/bs";

export default function Footer() {
  const bg = useColorModeValue("rgba(174, 177, 180, 0.95)", "rgba(12,14,18,0.95)");
  const border = useColorModeValue("blackAlpha.200", "whiteAlpha.200");
  const title = useColorModeValue("gray.900", "gray.100");
  const body = useColorModeValue("gray.700", "gray.300");
  const muted = useColorModeValue("gray.600", "gray.400");
  const link = useColorModeValue("blue.600", "blue.300");
  const cardBg = useColorModeValue("whiteAlpha.700", "whiteAlpha.100");
  const shadow = useColorModeValue("0 10px 24px rgba(0,0,0,0.08)", "0 12px 28px rgba(0,0,0,0.45)");

  const contentMaxW = "1240px";

  return (
    <Box  bg={bg} borderTop="1px solid" borderColor={border}>
      <Box maxW={contentMaxW} mx="auto" px={{ base: 4, md: 6 }} py={{ base: 2, md: 3 }}>
        {/* Top row */}
        <Flex
          direction={{ base: "column", lg: "row" }}
          align={{ base: "stretch", lg: "flex-end" }}
          justify="space-between"
          gap={{ base: 8, lg: 10 }}
        >
          {/* Left: Lab branding image */}
          <Box
            bg={cardBg}
            border="1px solid"
            borderColor={border}
            borderRadius="18px"
            boxShadow={shadow}
            p={{ base: 4, md: 5 }}
          >
            <Image
                src="nextcon_full.png"
                alt="NEXTCON Lab"
                h={{ base: "64px", md: "72px" }}
                w="auto"
                maxW="100%"
                objectFit="contain"
                objectPosition="left bottom"
                alignSelf="flex-end"
            />
            <Text mt={3} color={muted} fontSize={{ base: "sm", md: "sm" }} lineHeight="1.4">
              Next Generation Communications and Computing Networks (NEXTCON) Lab
            </Text>
          </Box>

          {/* Right: Director + contact info */}
        <Box
        flex="1"
        bg={cardBg}
        border="1px solid"
        borderColor={border}
        borderRadius="18px"
        boxShadow={shadow}
        p={{ base: 4, md: 5 }}
        >
        <Flex
        direction={{ base: "column", md: "row" }}
        align="flex-start"   // <-- top align
        gap={5}
        >
            {/* Professor Image */}
            <Box
                boxSize={{ base: "140px", md: "170px" }}   // larger size
                borderRadius="full"                        // fully round
                overflow="hidden"                          // required for round mask
                border="3px solid"
                borderColor={border}
                boxShadow={shadow}
                bg={useColorModeValue("white", "gray.800")}
                >
                <Image
                    src="BurakNewProfile.jpeg"
                    alt="Director"
                    objectFit="cover"                        // fills circle nicely
                    objectPosition="center top"              // keeps head aligned
                    w="100%"
                    h="100%"
                />
            </Box>

            {/* Text Content */}
            <Box>
                <Text fontSize={{ base: "md", md: "lg" }} fontWeight="800" color={title}>
                For more information, contact
                </Text>

                <Text mt={1} fontSize={{ base: "sm", md: "md" }} fontWeight="700" color={body}>
                Dr. Burak Kantarci
                </Text>

                <Text mt={1} fontSize="sm" color={muted} lineHeight="1.5">
                Professor & University Research Chair in AI-Enabled Secure Networking
                for Smart Critical Infrastructures
                <br />
                School of Electrical Engineering and Computer Science,
                Faculty of Engineering, University of Ottawa
                </Text>

                <Divider my={4} borderColor={border} />

                <HStack spacing={6} wrap="wrap">
                <HStack spacing={2}>
                    <Text fontSize="sm" fontWeight="700" color={muted}>
                    Email:
                    </Text>
                    <Link href="mailto:scvic-civic@uottawa.ca" color="blue.600" fontSize="sm">
                    scvic-civic@uottawa.ca
                    </Link>
                </HStack>

                <Link
                    href="https://www.linkedin.com/company/smart-connected-vehicles-innovation-centre/about/"
                    color="blue.600"
                    fontSize="sm"
                    fontWeight="700"
                    display="inline-flex"
                    alignItems="center"
                    gap={2}
                    isExternal
                >
                    <Icon as={BsLinkedin} />
                    Follow us on LinkedIn
                </Link>
                </HStack>
            </Box>
            </Flex>
          </Box>
        </Flex>

        {/* Bottom row */}
        <Divider my={{ base: 2, md: 5 }} borderColor={border} />

        <Flex direction={{ base: "column", md: "row" }} justify="space-between" gap={3} align={{ base: "flex-start", md: "center" }}>
          <Text fontSize="sm" color={muted}>
            © {new Date().getFullYear()} NEXTCON Lab • University of Ottawa
          </Text>
          <Text fontSize="sm" color={muted}>
            Smart Connected Vehicles Innovation Centre (SCVIC)
          </Text>
        </Flex>
      </Box>
    </Box>
  );
}